import _get from 'lodash/get';
import { fetcher } from '../../../utility/domUtils';

export const GET_CAMPAIGN = 'GET_CAMPAIGN';
export const GET_CAMPAIGN_SUCCESS = 'GET_CAMPAIGN_SUCCESS';
export const GET_CAMPAIGN_ERROR = 'GET_CAMPAIGN_ERROR';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DELETE_CAMPAIGN_ERROR = 'DELETE_CAMPAIGN_ERROR';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';
export const EDIT_CAMPAIGN_VALUE_ERROR = 'EDIT_CAMPAIGN_VALUE_ERROR';
export const EDIT_CAMPAIGN_VALUE_SUCCESS = 'EDIT_CAMPAIGN_VALUE_SUCCESS';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';

export function getCampaign(id) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_CAMPAIGN,
    });

    let resParams = {};
    return fetcher(`/donate/api/campaigns/${id}`, {
      method: 'GET',
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: GET_CAMPAIGN_ERROR,
            payload: { error },
          });

          return error;
        }
        const campaign = _get(responseJson, 'campaign');

        dispatch({
          type: GET_CAMPAIGN_SUCCESS,
          payload: campaign,
        });

        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: GET_CAMPAIGN_ERROR,
          payload: { error },
        });

        return error;
      });
  };
}

export function deleteCampaign(campaignId) {
  return (dispatch, getState) => {
    dispatch({
      type: DELETE_CAMPAIGN,
    });
    let resParams = {};
    return fetcher(`/donate/api/campaigns/${campaignId}`, {
      method: 'DELETE',
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: DELETE_CAMPAIGN_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        dispatch({
          type: DELETE_CAMPAIGN_SUCCESS,
          payload: responseJson,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: DELETE_CAMPAIGN_ERROR,
          payload: {
            error,
          },
        });
        return error;
      });
  };
}

export function updateCampaignStatus(campaignData) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CAMPAIGN,
    });
    let resParams = {};
    return fetcher(`/donate/api/campaigns/${campaignData.id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        campaignData,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: EDIT_CAMPAIGN_VALUE_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        const campaign = _get(responseJson, 'campaign');
        dispatch({
          type: EDIT_CAMPAIGN_VALUE_SUCCESS,
          payload: campaign,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: EDIT_CAMPAIGN_VALUE_ERROR,
          payload: {
            error,
          },
        });
        return error;
      });
  };
}
